import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { paymentService } from '@kss/api';
import type { PaymentCreate } from '@kss/api';
import { loadStoreOptions, loadUserOptions, loadInvoiceOptions, loadSalesOrderOptions } from '../shared/formLoaders';

const columns: BulkColumn<PaymentCreate>[] = [
  { key: 'paymentDate', header: 'Date', required: true, dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'amount', header: 'Amount', dataType: 'number', parse: parseNum as never, required: true, sample: '500' },
  { key: 'method', header: 'Method', sample: 'UPI' },
  { key: 'reference', header: 'Reference' },
  { key: 'description', header: 'Description' },
  { key: 'invoiceId', header: 'Invoice', dataType: 'lookup', loadOptions: loadInvoiceOptions },
  { key: 'salesOrderId', header: 'Sales order', dataType: 'lookup', loadOptions: loadSalesOrderOptions },
  { key: 'customerId', header: 'Customer', dataType: 'lookup', loadOptions: loadUserOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkPayment() {
  return (
    <BulkSpreadsheet<PaymentCreate> title="Bulk import payments" entityLabel="payment" backPath="/panel/payments" columns={columns} module="Payment"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, amount: Number(r.amount ?? 0), isActive: r.isActive ?? true }));
        const created = await paymentService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
